import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import LibraryService from '../../../core/service'

//getFilteredCompanies
export const getFilteredCompanies = createAsyncThunk(
  'library/filterCompanies/getFilteredCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getFilteredCompanies(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//downloadTemplateImportCompany
export const downloadTemplateImportCompany = createAsyncThunk(
  'library/filterCompanies/downloadTemplateImportCompany',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.downloadTemplateImportCompany(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

//download FilterCompany
export const downloadFilteredCompanies = createAsyncThunk(
  'library/filterCompanies/downloadFilteredCompanies',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.downloadFilteredCompanies(params)
      handleExport(response.data, response.filename)
      return rejectWithValue({ loading: false })
    } catch (err) {
      return rejectWithValue({ loading: false })
    }
  },
)

//Range
export const getScoreRangesCreditRisk = createAsyncThunk(
  'library/filterCompanies/getScoreRangesCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getScoreRangesCreditRisk(params)
      return res.success ? res.data : rejectWithValue('Error')
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getScoreRangesPerformance = createAsyncThunk(
  'library/filterCompanies/getScoreRangesPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getScoreRangesPerformance(params)
      return res.success ? res.data : rejectWithValue('Error')
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

//getAllIdCompanyFilter
export const getAllIdCompanyFilter = createAsyncThunk(
  'library/filterCompanies/getAllIdCompanyFilter',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getAllIdCompanyFilter(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
